<!--
	TaxonomySelectPanel.svelte

    new 08/18 - rewrite of <KeywordSelectPanel>

    This is a multi-component made up of:

        TaxonomySelectDropdown        // includes AutoComplete
        TaxonomyChips
        TreeViewer

    Each gets passed a store prop which is the master object being edited.

        masterCreateService
        masterUpdateService

    Selecting from the TreeViewers or AutoComplete will add Chips.

-->

<script>
    import { onMount } from 'svelte';

    // TCARE components
    import TaxonomySelectDropdown from './TaxonomySelectDropdown.svelte';
	import TaxonomyChips from './TaxonomyChips.svelte';
	import TreeViewer from '../tree-viewer/TreeViewer.svelte';

    // SMUI components
    import Checkbox from '@smui/checkbox';

    export let store;
    export let taxName;

    $: taxonomyObj = $store.taxonomies[taxName] || null;        // the JS object - not API data
    $: isShowingTreeViewer = false;

    onMount(() => {
        // console.log('');
        // console.log('TaxonomySelectPanel onMount');
        // console.log('received prop $store:');
        // console.log($store);
        // console.log('taxName');
        // console.log(taxName);
        // console.log('');
    })

    const onTreeNodeClick = (node) => {
        $store = $store;
    }

</script>

<style>
    .tax-select-panel {
        width: 100%;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
    }
    
    .flex-block {
        min-height: 450px;
        /* border: 1px solid blue; */
    }

    .padded-content {
        padding: 10px;
    }

    .tree-wrapper {
        width: 98%;
        height: 380px;
        overflow-y: scroll;
        /* border: 1px solid blue; */
    }

    /* override the TreeViewer's 500px width */
    :global(.tree-wrapper .tree-viewer) {
        width: 98%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if store}
    <div class="tax-select-panel">

        <div class="flex-block w-49 padded-content">
            <TaxonomySelectDropdown {store} {taxName}/>
            <div class="spacer-h-20"></div>
            <TaxonomyChips {store} {taxName} />
        </div>

        <div class="flex-block w-49">        
            <div class="flex-row jc-start">
                <Checkbox bind:checked={isShowingTreeViewer} tabindex={1} /> Show Keyword selection trees
            </div>
            <div class="spacer-h-20"></div>

            {#if isShowingTreeViewer}
                <div class="spacer-h-15"></div>
                <div class="tree-wrapper">
                    <TreeViewer tree={taxonomyObj.forest.items} onNodeClick={onTreeNodeClick} />
                </div>
            {/if}
        </div>

        <div class="spacer-h-50"></div>
    </div>
{/if}